import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  LayoutWrapperMain,
  Page,
  MasterReasonComponent,
} from '../../components';
import config from '../../config';
import './masterreasonmanagement.global.scss';

interface Props {
  scrollingDisabled: boolean,
  intl: any,
}

const MasterReasonManagementPageComponent: React.FC<Props> = (props: Props) => {
  const {
    intl,
    scrollingDisabled,
  } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'MasterReason.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <MasterReasonComponent />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
  // submitSignup: (dispatch: any, data: any) => dispatch(Signup(data)),
});

const MasterReasonManagementPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(MasterReasonManagementPageComponent);

export default MasterReasonManagementPage;
